// Keyword arrays for routing logic
export const KB_KEYWORDS = [
  'place', 'location', 'where', 'find', 'restaurant', 'hotel', 'food', 'museum', 
  'park', 'cafe', 'store', 'shop', 'eat', 'sleep', 'attraction', 'to do', 
  'things to do', 'nearby', 'near by', 'close to', 'hostel', 'cheap hotel', 
  'cheap food', 'expensive hotel', 'good food', 'activities', 'famous', 
  'important', 'renowned'
];

export const GPT_KEYWORDS = [
  'explain', 'why', 'how', 'describe', 'details', 'history', 'fact', 'facts', 
  'meaning', 'define', 'definition', 'tips', 'tricks', 'how to', 'how long', 
  'how far', 'quick', 'fast', 'is it'
];

// Waiting text arrays for different query types
export const HOTEL_MESSAGES = [
  "🏨 Finding the best hotels for you...",
  "🛏️ Searching for perfect accommodations...",
  "⭐ Looking up top-rated hotels...",
  "🏩 Discovering great places to stay..."
];

export const FOOD_MESSAGES = [
  "🍽️ Searching for delicious restaurants...",
  "🍜 Finding the best food spots...",
  "🥘 Looking up amazing dining options...",
  "🍴 Discovering great places to eat..."
];

export const ATTRACTION_MESSAGES = [
  "🎯 Finding amazing attractions...",
  "🏛️ Discovering must-visit places...",
  "🎪 Looking up exciting activities...",
  "🌟 Searching for top attractions..."
];

export const SEARCH_MESSAGES = [
  "🔍 Searching our database for the best places...",
  "🏝️ Finding perfect spots for you...",
  "📍 Looking up locations and recommendations...",
  "✨ Discovering amazing places nearby...",
  "🎯 Searching for the best options...",
  "🗺️ Exploring places that match your needs..."
];

export const HOW_WHY_MESSAGES = [
  "🤔 Analyzing your question...",
  "💭 Thinking through the details...",
  "🧠 Processing the information...",
  "📝 Preparing a comprehensive answer..."
];

export const EXPLAIN_MESSAGES = [
  "📚 Gathering information to explain...",
  "🔍 Researching the details...",
  "📖 Preparing a detailed explanation...",
  "💡 Crafting a clear description..."
];

export const CHAT_MESSAGES = [
  "🤔 Thinking about your question...",
  "💭 Processing your request...",
  "🧠 Analyzing the information...",
  "📚 Gathering relevant details...",
  "✨ Preparing a helpful response...",
  "🎯 Crafting the perfect answer..."
];

export const DEFAULT_MESSAGES = [
  "💬 Getting ready to help you...",
  "✨ Preparing something special...",
  "🎯 Working on your request...",
  "🚀 Almost ready with your answer..."
];

// Category-specific messages for unified chat system
export const CATEGORY_MESSAGES = {
  BUDGET: [
    "💰 Finding budget-friendly options for you...",
    "🏷️ Searching for affordable places...",
    "💵 Looking up great value options...",
    "🎯 Discovering budget accommodations..."
  ],
  LUXURY: [
    "✨ Searching for luxury experiences...",
    "👑 Finding premium accommodations...",
    "🌟 Discovering exclusive options...",
    "💎 Looking up high-end places..."
  ],
  DIETARY: [
    "🌱 Looking for dietary-friendly places...",
    "🥗 Searching for suitable restaurants...",
    "🍽️ Finding safe dining options...",
    "✅ Discovering dietary-compliant spots..."
  ],
  ACTIVITY: [
    "🏄 Finding exciting activities...",
    "🎯 Searching for adventure spots...",
    "⛰️ Looking up activity locations...",
    "🌊 Discovering perfect activity spots..."
  ],
  COMPARISON: [
    "⚖️ Comparing locations for you...",
    "📊 Analyzing both options...",
    "🔍 Evaluating the differences...",
    "💭 Comparing places side by side..."
  ],
  ITINERARY: [
    "🗺️ Planning your perfect trip...",
    "📅 Creating your itinerary...",
    "✈️ Organizing your travel plan...",
    "🎒 Building your journey..."
  ],
  GENERAL: SEARCH_MESSAGES,
  OUT_OF_SCOPE: [
    "🤔 Processing your question...",
    "💭 Thinking about your request...",
    "📚 Gathering information...",
    "💬 Working on your query..."
  ]
};
